import AdminProviderList from "./providerList/providerList";

export default AdminProviderList;
